import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {AsynchronousUseCaseType} from '@prompt-bridge/shared/validations';

import {PromptBridgeNotificationsFactoryParams} from '../types/PromptBridgeNotificationsFactoryParams';
import {getDeliveryNoteNotifications} from './getDeliveryNoteNotifications';

export const promptBridgeNotificationsFactory = (
  useCaseType: AsynchronousUseCaseType,
  params: PromptBridgeNotificationsFactoryParams
): void => {
  const result = match(useCaseType)
    .with('extractDeliveryNoteDocument', () => getDeliveryNoteNotifications(params))
    .otherwise(() => null);

  if (isNil(result)) {
    return;
  }

  if (result.shouldUpdate && result.updateProps) {
    params.updateNotification(params.notificationId, result.updateProps);
    return;
  }

  if (result.shouldShow && result.notificationProps) {
    params.showNotification(result.notificationProps);
    return;
  }
};
